var supportsPassive = false;
try {
    var opts = Object.defineProperty({}, 'passive', {
        get: function () {
            supportsPassive = true;
        },
    });
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.addEventListener('test', null, opts);
}
catch (e) {
    supportsPassive = false;
}
export { supportsPassive };
//# sourceMappingURL=supportsPassiveEventListeners.js.map